const styles = (theme) => ({
    containerNavigation: {
        marginBottom: '20px',
    },
    revisionNumber: {
        backgroundColor: theme.palette.primary.main,
        color: '#fff',
        borderRadius: '50%',
        width: '48px',
        height: '48px',
        lineHeight: '48px',
        textAlign: 'center',
        fontSize: '18px',
        marginRight: '20px',
    },
    feedbackNavigation: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        fontSize: '16px',
        fontWeight: '500',
        textTransform: 'uppercase',
    },
    navegation: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        fontSize: '16px',
        color: '#333',
        height: '100%',
    },
    line: {
        width: '100%',
        height: '1px',
        border: 'none',
        backgroundColor: theme.palette.primary.main,
    },
    table: {
        margin: '0 0 0 0',
    },
    tableRow: {
        verticalAlign: 'middle',
    },
    headTableCell: {
        backgroundColor: '#eee',
        color: '#444',
    },
    addButton: {
        borderRadius: '30px',
        padding: '5px 20px',
        border: '1px solid #ccc',
        borderColor: theme.palette.primary.main,
        color: theme.palette.primary.main,
        backgroundColor: theme.palette.common.white,
        alignItems: 'center',
        display: 'flex',
        textTransform: 'uppercase',
        fontWeight: 'bold',
        fontFamily: theme.typography.fontFamily,
        float: 'right',
    },
    btnSigleAction: {
        minWidth: '30px',
        height: '30px',
        lineHeight: '30px',
        borderRadius: '50%',
        display: 'inline-flex',
        color: theme.palette.common.white,
        marginRight: '5px',
        padding: '0',
        fontSize: '16px',
    },
    accordion: {
        marginBottom: '30px',
    },
    description: {
        color: '#666',
    },
});

export default styles;
